import styled from 'styled-components';

import theme from '../../theme';

export const BuildingDetailsStyled = styled.div`
  & .section-title {
    margin-bottom: 20px;
  }
  @media (max-width: 480px) {
    & .buildingInfo {
      flex-direction: row;
    }
  }
`;
export const BlueprintDetailsStyled = styled.div`
  max-width: 758px;
  padding-bottom: 50px;
  & .section-title {
    margin-bottom: 20px;
  }
  & .value {
    margin-bottom: 12px;
  }

  @media ${theme.breakpoints.sm} {
    .blueprintInfo {
      flex-direction: row;
    }
  }
`;
